import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { TimeReportingFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { CommentsFormContainerProps } from "models/propTypes/timeReportingPropTypes";
import { WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";
//#endregion
//#region components
import CommentsForm from "./commentsForm";
//#endregion
import * as Yup from "yup";

const CommentsFormContainer: ForwardRefRenderFunction<FormHandles, CommentsFormContainerProps> = (props, ref) => {
  const { values, weekLockEntries } = props;

  const validationSchema = Yup.object<TimeReportingFormTypes.WeekComments>({
    categoryId: Yup.number(),
  });

  const handleSubmit = async (vals: TimeReportingFormTypes.WeekComments) => {
    return vals;
  };

  const isCommentDisabled = (
    commentType: WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType,
    day: string,
    row?: TimeReportingFormTypes.WeeklyTimeReportRow
  ) => {
    if (((row as any)[day] ?? 0) <= 0) {
      return true;
    }

    if (commentType === WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType.Internal) {
      return false;
    }

    const projectLocked =
      (weekLockEntries && (weekLockEntries as any)[day]) || (row?.weekLocks && (row?.weekLocks as any)[day]);

    if (!projectLocked) {
      return false;
    }
    return true;
  };

  return (
    <CommentsForm
      ref={ref}
      {...props}
      defaultValues={values}
      validationSchema={validationSchema}
      handleSubmit={handleSubmit}
      isCommentDisabled={isCommentDisabled}
    />
  );
};

export default forwardRef(CommentsFormContainer);
